<template>
  <div class="content-body">
    <div class="top">
      <div class="left-z">
        <div>账号信息</div>
        <div class="status">状态：<span>审核通过</span></div>
      </div>
      <div class="btn">
        <!-- <el-button type="primary" size="small">修改密码</el-button> -->
      </div>
    </div>
    <div class="body">
      <div class="left-content">
        <div class="line">
          <div class="title"><span>*</span>企业名称：</div>
          <div class="content" v-text="user_info.company_name"></div>
        </div>
        <div class="line">
          <div class="title"><span>*</span>企业地址：</div>
          <div class="content" v-text="user_info.address"></div>
        </div>
        <div class="line">
          <div class="title"><span>*</span>运营人员姓名：</div>
          <div class="content" v-text="user_info.contact_name"></div>
        </div>
        <div class="line">
          <div class="title"><span>*</span>运营人员手机号：</div>
          <div class="content" v-text="user_info.contact_mobile"></div>
        </div>
        <div class="line">
          <div class="title"><span>*</span>运营人员QQ：</div>
          <div class="content" v-text="user_info.contact_qq"></div>
        </div>
        <div class="line">
          <div class="title"><span>*</span>公司固定电话：</div>
          <div class="content" v-text="user_info.company_phone"></div>
        </div>
        <div class="line">
          <div class="title"><span>*</span>工商营业执照号：</div>
          <div class="content" v-text="user_info.company_business_no"></div>
        </div>
        <div class="line" style="width: 1400px;">
          <div class="title"><span>*</span>资质图片：</div>
          <div class="content" style="width: 1200px;">
            <el-image style="width: 200px; height: 200px; margin: 0 10px 10px 0;" :src="getImg(item.url)" :preview-src-list="srcList" v-for="(item, index) in user_info.company_business_res" :key="index"></el-image>
          </div>
        </div>
        <div class="line">
          <div class="title"><span>*</span>账户注册时间：</div>
          <div class="content" v-text="getDate(user_info.create_at)"></div>
        </div>

        <div style="height: 200px;"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  data() {
    return {
      srcList: [],
      user_info: []
    };
  },
  mounted() {
    this.user_info = JSON.parse(sessionStorage.getItem('user_info'));
    if (this.user_info.company_business_res.length) {
      const srcList = [];
      for (const item of this.user_info.company_business_res) {
        srcList.push(this.$Config.apiUrl + item.url);
      }
      this.srcList = srcList;
    }
    setTimeout(() => {
      this.$function.hiddenLoading();
    }, 200);
  },
  methods: {
    getImg(img) {
		  return this.$Config.apiUrl + img;
    },
    getDate(time) {
      return this.$function.formatDate(time);
    }
  }
};
</script>

<style lang="less" scoped>
  .top {
    height: 54px;
    background-color: #f9f9f9;
    margin-bottom: 31px;
    font-size: 16px;
    font-weight: 700;
    color: #333;
    padding-left: 22px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left-z {
      display: flex;
    }
    .status {
      font-size: 14px;
      color: #999;
      font-weight: 400;
      margin-left: 30px;
      span {
        color: #0782c3;
      }
    }
    .btn {
      float: right;
      margin-right: 40px;
    }
  }

  .left-content {
    width: calc(100% - 46px);
    padding: 0 23px;
    .line {
      line-height: 22px;
      margin-bottom: 30px;
      display: flex;
      .title {
        width: 229px;
        font-size: 14px;
        color: #999;
        text-align: right;
        padding-right: 29px;
        span {
          color: #ff2020;
          font-size: 14px;
        }
      }
      .content {
        font-size: 14px;
        color: #333;
        word-break:break-all;
      }
    }
  }

</style>
